import { CreditorDataList } from "Components/CreditorDataList"
import React from "react"
import { useVendor } from "Shared/queries/vendors/vendor.queries"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"

interface PurchaseOrderVendorTabContentProps {
    purchaseOrder: PurchaseOrder
}

export const PurchaseOrderVendorTabContent = ({ purchaseOrder }: PurchaseOrderVendorTabContentProps) => {
    const { data: purchaseOrderVendor } = useVendor(purchaseOrder.vendor?._id, true)

    if (!purchaseOrderVendor) {
        return <></>
    }

    return <CreditorDataList documentCreditor={purchaseOrderVendor} document={purchaseOrder} isUpdating={false} canEditItems={false} />
}
